import { ComponentPropsWithoutRef } from 'react'

import { isDevelopment } from '@/utils/isDevelopment'

import { ContentfulText } from '@/components/Contentful/common/ContentfulText'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Article.hooks'

type Props = Omit<ComponentPropsWithoutRef<typeof ContentfulText>, 'field'> & {
	prefix?: string
	suffix?: string
}

export function ArticleChildrenHeading({ prefix, suffix, ...rest }: Props) {
	const entry = useEntry()

	if ('error' in entry) {
		return isDevelopment() ? <Warning className={rest.className}>{entry.error}</Warning> : null
	}

	const { title } = entry?.data ?? {}
	const data = `${prefix} ${title} ${suffix}`.trim()

	return <ContentfulText {...rest} field={{ data }} />
}
